var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getFirestore, onSnapshot, collection, doc, updateDoc, getDoc, getDocs, setDoc, deleteDoc, } from "firebase/firestore";
//#region Converters
var user_data_in_team_converter = {
    toFirestore: function (jsData) {
        var _a;
        return {
            Path: jsData.path,
            DisplayName: jsData.displayName,
            IsAdmin: jsData.isAdmin,
            State: jsData.state,
            LastUpdate: (_a = jsData.lastUpdate) !== null && _a !== void 0 ? _a : new Date(),
        };
    },
    fromFirestore: function (snapshot, opts) {
        var data = snapshot.data(opts);
        return {
            path: data.Path,
            displayName: data.DisplayName,
            isAdmin: data.IsAdmin,
            state: data.State,
            lastUpdate: data.LastUpdate,
        };
    },
};
var team_data_in_user_converter = {
    toFirestore: function (js) {
        return {
            Path: js.path,
            Memo: js.memo,
            JoinDate: js.joinDate,
        };
    },
    fromFirestore: function (snapshot, opts) {
        var data = snapshot.data(opts);
        return {
            path: data.Path,
            memo: data.Memo,
            joinDate: data.JoinDate,
        };
    },
};
var master_user_data_converter = {
    toFirestore: function (js) {
        var _a;
        return {
            DefaultDisplayName: js.defaultDisplayName,
            DefaultIconURL: js.defaultIconURL,
            LastUpdate: (_a = js.lastUpdate) !== null && _a !== void 0 ? _a : new Date(),
        };
    },
    fromFirestore: function (snapshot) {
        var data = snapshot.data();
        return {
            defaultDisplayName: data.DefaultDisplayName,
            defaultIconURL: data.DefaultIconURL,
            lastUpdate: data.LastUpdate,
        };
    },
};
var team_data_converter = {
    toFirestore: function (js) {
        var _a;
        return {
            DisplayName: js.displayName,
            Memo: js.memo,
            CreateDate: js.createDate,
            LastUpdate: (_a = js.lastUpdate) !== null && _a !== void 0 ? _a : new Date(),
        };
    },
    fromFirestore: function (snapshot) {
        var data = snapshot.data();
        return {
            displayName: data.DisplayName,
            memo: data.Memo,
            createDate: data.CreateDate,
            lastUpdate: data.LastUpdate,
        };
    },
};
//#endregion
//#endregion
export var STATE_LEAVING = "leaving";
export var STATE_WORKING = "working";
/** dev-daemonのDBを統括する */
var DevDaemonDBController = /** @class */ (function () {
    //#endregion
    /** DevDaemonDBControllerインスタンスを初期化する */
    function DevDaemonDBController(app) {
        /** ユーザIDのキャッシュ */
        this._user_id = "";
        /** マスタユーザデータのキャッシュ */
        this.user_data_cache = undefined;
        /** チームIDのキャッシュ */
        this._team_id = "";
        /** チームに所属するユーザの情報(State等)の変更通知購読を解除する関数 */
        this.unsubscribe_team_data = undefined;
        /** DB内において現在のユーザの情報が記録された位置 */
        this.user_data_master_ref = undefined;
        /** DB内において, 現在のチーム情報が記録された位置 */
        this.team_data_ref = undefined;
        /** DB内において, 現在表示中のチームに記録された自身の情報が記録された位置 */
        this.user_data_in_team_ref = undefined;
        this.db = getFirestore(app);
    }
    //#endregion
    //#region Ref getters
    /** DocumentReference<MasterUserData>を取得する */
    DevDaemonDBController.prototype.getUserDataMasterRef = function (id) {
        return doc(this.db, "/users", id).withConverter(master_user_data_converter);
    };
    /** DocumentReference<TeamData>を取得する */
    DevDaemonDBController.prototype.getTeamDataRef = function (id) {
        return doc(this.db, "/teams", id).withConverter(team_data_converter);
    };
    /** DocumentReference<UserDataInTeam>を取得する */
    DevDaemonDBController.prototype.getUserDataInTeamRef = function (team_id, user_id) {
        return doc(this.db, "/teams/" + team_id + "/users", user_id).withConverter(user_data_in_team_converter);
    };
    /** DocumentReference<TeamDataInUser>を取得する */
    DevDaemonDBController.prototype.getTeamDataInUserRef = function (team_id, user_id) {
        return doc(this.db, "/users", user_id, "teams", team_id).withConverter(team_data_in_user_converter);
    };
    Object.defineProperty(DevDaemonDBController.prototype, "userID", {
        //#region Property: userID
        /** ログイン中のユーザのID */
        get: function () {
            return this._user_id;
        },
        enumerable: false,
        configurable: true
    });
    /** ログイン中のユーザのID */
    DevDaemonDBController.prototype.setUserID = function (id) {
        return __awaiter(this, void 0, Promise, function () {
            var data_ref, docSnap, msg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data_ref = this.getUserDataMasterRef(id);
                        return [4 /*yield*/, getDoc(data_ref).catch(function (e) {
                                console.error("Error has occured : ", e);
                                throw e;
                            })];
                    case 1:
                        docSnap = _a.sent();
                        if (!docSnap.exists()) {
                            msg = "userID : " + id + " was not found.";
                            console.error(msg);
                            throw new Error(msg);
                        }
                        this._user_id = id;
                        this.user_data_master_ref = data_ref;
                        this.user_data_cache = docSnap.data();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(DevDaemonDBController.prototype, "userMasterData", {
        //#endregion
        //#region Property: userMasterData
        /** ログイン中のユーザのIDに基づくマスターデータ */
        get: function () {
            var _a;
            return (_a = this.user_data_cache) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DevDaemonDBController.prototype, "teamID", {
        //#endregion
        //#region  Property: teamID
        /** 現在使用中のチームのID */
        get: function () {
            return this._team_id;
        },
        enumerable: false,
        configurable: true
    });
    /** 現在使用中のチームのID */
    DevDaemonDBController.prototype.setTeamID = function (id) {
        return __awaiter(this, void 0, Promise, function () {
            var data_ref, docSnap, msg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data_ref = this.getTeamDataRef(id);
                        return [4 /*yield*/, getDoc(data_ref).catch(function (e) {
                                console.error("Error has occured : ", e);
                                throw e;
                            })];
                    case 1:
                        docSnap = _a.sent();
                        //指定のteamIDが存在していたかチェック
                        if (!docSnap.exists()) {
                            msg = "teamID : " + id + " was not found.";
                            console.error(msg);
                            throw new Error(msg);
                        }
                        //Team内にUserがいるかどうか判定 => いなかったら失敗
                        //todo (DB内でデータ齟齬が発生していない限り問題はない)
                        //既に購読していたら, 一度購読解除する
                        if (this.unsubscribe_team_data != null) {
                            this.unsubscribe_team_data();
                        }
                        //teamIDを更新
                        this._team_id = id;
                        //参照設定を更新
                        this.team_data_ref = data_ref;
                        this.user_data_in_team_ref = this.getUserDataInTeamRef(id, this.userID);
                        //グループに所属する各員のデータ変更をSubscribe
                        this.unsubscribe_team_data = onSnapshot(collection(this.db, data_ref.path, "users"), function (doc) {
                            var states = {};
                            //各員のStateを取得
                            doc.forEach(function (d) {
                                var data = d.data();
                                if ((data === null || data === void 0 ? void 0 : data.State) != null && (data === null || data === void 0 ? void 0 : data.DisplayName) != null) {
                                    states[data.DisplayName] = data.State;
                                }
                            });
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    //#endregion
    /** 現在使用中のチーム内のマスターデータの取得 */
    DevDaemonDBController.prototype.getUsersDataInTeam = function () {
        var _a;
        return __awaiter(this, void 0, Promise, function () {
            var data_ref, ret_arr, values;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.team_data_ref == null) {
                            return [2 /*return*/];
                        }
                        data_ref = collection(this.db, (_a = this.team_data_ref) === null || _a === void 0 ? void 0 : _a.path, "users").withConverter(user_data_in_team_converter);
                        ret_arr = [];
                        return [4 /*yield*/, getDocs(data_ref)];
                    case 1:
                        values = _b.sent();
                        values.forEach(function (doc) { return ret_arr.push(doc.data()); });
                        return [2 /*return*/, ret_arr];
                }
            });
        });
    };
    /** 自身が所属するチームのリストを取得する */
    DevDaemonDBController.prototype.getJoiningTeamList = function () {
        var _a;
        return __awaiter(this, void 0, Promise, function () {
            var data_ref, ret_arr, values;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.user_data_master_ref == null) {
                            throw new Error("UserID is not set");
                        }
                        data_ref = collection(this.db, (_a = this.user_data_master_ref) === null || _a === void 0 ? void 0 : _a.path, "teams").withConverter(team_data_in_user_converter);
                        ret_arr = [];
                        return [4 /*yield*/, getDocs(data_ref)];
                    case 1:
                        values = _b.sent();
                        values.forEach(function (doc) { return ret_arr.push(doc.data()); });
                        return [2 /*return*/, ret_arr];
                }
            });
        });
    };
    //#region  Property: myState
    /** 自身の状態 (Working/Leavingなど) */
    DevDaemonDBController.prototype.getMyState = function () {
        var _a, _b;
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (this.user_data_in_team_ref == null) {
                            throw new Error("TeamID is not set");
                        }
                        return [4 /*yield*/, getDoc(this.user_data_in_team_ref)];
                    case 1: return [2 /*return*/, (_b = (_a = (_c.sent()).data()) === null || _a === void 0 ? void 0 : _a.state) !== null && _b !== void 0 ? _b : ""];
                }
            });
        });
    };
    Object.defineProperty(DevDaemonDBController.prototype, "myState", {
        /** 自身の状態 (Working/Leavingなど) */
        set: function (value) {
            if (this.team_data_ref == null || this.user_data_in_team_ref == null) {
                throw new Error("TeamID is not set");
            }
            updateDoc(this.user_data_in_team_ref, {
                state: value,
                lastUpdate: new Date(),
            });
            updateDoc(this.team_data_ref, { lastUpdate: new Date() });
        },
        enumerable: false,
        configurable: true
    });
    //#endregion
    /** 新しいチームを作成する */
    DevDaemonDBController.prototype.createNewTeam = function (team_id, config) {
        return __awaiter(this, void 0, Promise, function () {
            var newTeamDataRef, userDataInNewTeamRef;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isTeamIDAlreadyExists(team_id)];
                    case 1:
                        if (_a.sent()) {
                            throw new Error("TeamID (" + team_id + ") is already exist.");
                        }
                        newTeamDataRef = this.getTeamDataRef(team_id);
                        userDataInNewTeamRef = this.getUserDataInTeamRef(team_id, this.userID);
                        return [4 /*yield*/, setDoc(newTeamDataRef, config)];
                    case 2:
                        _a.sent();
                        /*setDoc(userDataInNewTeamRef, {
                          path: this.user_data_master_ref?.path ?? "",
                          displayName: this.user_data_cache?.defaultDisplayName ?? this.userID,
                          isAdmin: true,
                          state: "Working",
                          lastUpdate: new Date()
                        });*/
                        return [4 /*yield*/, this.addMemberToTeam(this.userID, team_id, true)];
                    case 3:
                        /*setDoc(userDataInNewTeamRef, {
                          path: this.user_data_master_ref?.path ?? "",
                          displayName: this.user_data_cache?.defaultDisplayName ?? this.userID,
                          isAdmin: true,
                          state: "Working",
                          lastUpdate: new Date()
                        });*/
                        _a.sent();
                        this.team_data_ref = newTeamDataRef;
                        this.user_data_in_team_ref = userDataInNewTeamRef;
                        return [2 /*return*/];
                }
            });
        });
    };
    /** 現在表示しているチームを削除する (管理者のみ) */
    DevDaemonDBController.prototype.deleteCurrentTeam = function (delete_even_if_not_admin) {
        if (delete_even_if_not_admin === void 0) { delete_even_if_not_admin = false; }
        return __awaiter(this, void 0, Promise, function () {
            var userDataInTeam, values;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.userID == "") {
                            throw new Error("UserID was not set");
                        }
                        if (this.teamID == "" || this.team_data_ref == null) {
                            throw new Error("Team not selected");
                        }
                        if (this.user_data_in_team_ref == null) {
                            // NULL合体代入演算子を使用すると Unexpected tokenと言われてしまうため, この方式を取る
                            this.user_data_in_team_ref = this.getUserDataInTeamRef(this.teamID, this.userID);
                        }
                        return [4 /*yield*/, getDoc(this.user_data_in_team_ref)];
                    case 1:
                        userDataInTeam = _a.sent();
                        if (!userDataInTeam.exists())
                            throw new Error("Team or User was not found on the database");
                        //「ユーザではなかったとしても削除する」オプションが指定されていない場合,
                        //当該Teamの管理者以外はチームを削除できない
                        if (!delete_even_if_not_admin && !userDataInTeam.data().isAdmin)
                            throw new Error("Permission Denied");
                        //チームのメンバーデータ変更検知イベントを購読しているなら, 購読解除する
                        if (this.unsubscribe_team_data != null) {
                            this.unsubscribe_team_data();
                            this.unsubscribe_team_data = undefined;
                        }
                        return [4 /*yield*/, getDocs(collection(this.db, this.team_data_ref.path, "users").withConverter(user_data_in_team_converter))];
                    case 2:
                        values = _a.sent();
                        values.forEach(function (v) {
                            //ユーザに関連付けられたチーム参加情報を削除する
                            deleteDoc(v.data().path);
                            //メンバー情報を削除する
                            deleteDoc(v.ref);
                        });
                        //Teamデータ(document)を削除する
                        deleteDoc(this.team_data_ref).then(function () {
                            _this.team_data_ref = undefined;
                            _this.user_data_in_team_ref = undefined;
                            _this._team_id = "";
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    /** 指定の (OR 現在表示している) チームに指定のユーザを追加する */
    DevDaemonDBController.prototype.addMemberToTeam = function (user_id, team_id, isAdmin) {
        var _a;
        if (isAdmin === void 0) { isAdmin = false; }
        return __awaiter(this, void 0, Promise, function () {
            var user_id_ref, userInTeamRef, user_data_master;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        //デフォルトは現在表示しているチーム
                        if (team_id == null) {
                            team_id = this.teamID;
                        }
                        //引数のバリデーション
                        if (team_id == null) {
                            throw new Error("Team ID was not set");
                        }
                        if (user_id == null) {
                            throw new Error("User ID was not set");
                        }
                        user_id_ref = this.getUserDataMasterRef(user_id);
                        return [4 /*yield*/, this.isDocumentAlreadyExists(user_id_ref)];
                    case 1:
                        if (!(_b.sent())) {
                            throw new Error("UserID was not found in the DB");
                        }
                        return [4 /*yield*/, this.isTeamIDAlreadyExists(team_id)];
                    case 2:
                        if (!(_b.sent())) {
                            throw new Error("TeamID was not found in the DB");
                        }
                        userInTeamRef = this.getUserDataInTeamRef(team_id, user_id);
                        return [4 /*yield*/, this.isDocumentAlreadyExists(userInTeamRef)];
                    case 3:
                        if (_b.sent()) {
                            throw new Error("User is already in the Team");
                        }
                        return [4 /*yield*/, getDoc(this.getUserDataMasterRef(user_id))];
                    case 4:
                        user_data_master = (_b.sent()).data();
                        return [4 /*yield*/, Promise.all([
                                //ユーザをチームに追加する
                                setDoc(userInTeamRef, {
                                    path: user_id_ref,
                                    displayName: (_a = user_data_master === null || user_data_master === void 0 ? void 0 : user_data_master.defaultDisplayName) !== null && _a !== void 0 ? _a : user_id,
                                    isAdmin: isAdmin,
                                    state: STATE_LEAVING,
                                    lastUpdate: new Date(),
                                }),
                                //ユーザのマスタデータに「チームに参加した」ことを追加する
                                setDoc(this.getTeamDataInUserRef(team_id, user_id), {
                                    path: this.getTeamDataRef(team_id),
                                    memo: "",
                                    joinDate: new Date(),
                                }),
                            ])];
                    case 5:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /** 現在表示しているチームから指定のユーザを削除する */
    DevDaemonDBController.prototype.removeMemberFromCurrentTeam = function (user_id) {
        var _a, _b;
        return __awaiter(this, void 0, Promise, function () {
            var users_arr;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (this.userID == null) {
                            throw new Error("Controller UserID not set");
                        }
                        if (this.teamID == null || this.team_data_ref == null) {
                            throw new Error("TeamID not set");
                        }
                        //デフォルトでは自身を削除する
                        if (user_id == null) {
                            user_id = this.userID;
                        }
                        if (!(user_id != this.userID)) return [3 /*break*/, 2];
                        return [4 /*yield*/, getDoc((_a = this.user_data_in_team_ref) !== null && _a !== void 0 ? _a : this.getUserDataInTeamRef(this.teamID, this.userID))];
                    case 1:
                        if (!((_b = (_c.sent()).data()) === null || _b === void 0 ? void 0 : _b.isAdmin)) {
                            throw new Error("Permission Denied");
                        }
                        _c.label = 2;
                    case 2: return [4 /*yield*/, getDocs(collection(this.db, this.team_data_ref.path, "users").withConverter(user_data_in_team_converter))];
                    case 3:
                        users_arr = _c.sent();
                        if (users_arr.docs.length <= 0) {
                            this.deleteCurrentTeam();
                            return [2 /*return*/];
                        }
                        //チームに記録された「ユーザの情報」を削除する
                        deleteDoc(this.getUserDataInTeamRef(this.teamID, user_id));
                        //ユーザに記録された「所属チームの情報」を削除する
                        deleteDoc(this.getTeamDataInUserRef(this.teamID, user_id));
                        return [2 /*return*/];
                }
            });
        });
    };
    DevDaemonDBController.prototype.isDocumentAlreadyExists = function (doc_ref) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getDoc(doc_ref)];
                    case 1: return [2 /*return*/, (_a.sent()).exists()];
                }
            });
        });
    };
    /** 指定のユーザIDが既に作成済みかどうかを確認する */
    DevDaemonDBController.prototype.isUserIDAlreadyExists = function (user_id) {
        return this.isDocumentAlreadyExists(this.getUserDataMasterRef(user_id));
    };
    /** 指定のチームIDが既に作成済みかどうかを確認する */
    DevDaemonDBController.prototype.isTeamIDAlreadyExists = function (team_id) {
        return this.isDocumentAlreadyExists(this.getTeamDataRef(team_id));
    };
    DevDaemonDBController.prototype.isUserAlreadyInTheTeam = function (team_id, user_id) {
        return this.isDocumentAlreadyExists(this.getUserDataInTeamRef(team_id, user_id));
    };
    /** ユーザデータを新規作成する */
    DevDaemonDBController.prototype.createNewMasterUserData = function (user_id, user_data) {
        return __awaiter(this, void 0, Promise, function () {
            var doc_ref;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isUserIDAlreadyExists(user_id)];
                    case 1:
                        if (_a.sent()) {
                            throw new Error("UserID already exists");
                        }
                        doc_ref = this.getUserDataMasterRef(user_id);
                        return [4 /*yield*/, setDoc(doc_ref, user_data)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return DevDaemonDBController;
}());
export { DevDaemonDBController };



//////////////////
// WEBPACK FOOTER
// ./src/DevDaemonDBController.ts
// module id = 17
// module chunks = 0